import { createAction } from '../helpers';
import constants from './constants';

export const setBranchID = createAction(constants.setBranchID);
